import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const CountryParameterRoutes = [
  {
    path: '/country-parameters',
    name: 'CountryParameters',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'country_parameter:list'
    }
  },
  {
    path: '/country-parameters/:id',
    name: 'UpdateCountryParameter',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'country_parameter:update'
    }
  },
  {
    path: '/country-parameters/view/:id',
    name: 'GetCountryParameter',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'country_parameter:get'
    }
  }
]
